<template>
  <div
    :style="{ width: width, height: height }"
    class="echartsTraingle"
    ref="echartsTraingle"
  ></div>
</template>

<script>
import * as echarts from "echarts";
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/src/utils/resize-event";
export default {
  name: "echarts-traingle",
  props: {
    // 宽
    width: {
      type: [Number, String],
      default: "100%",
    },
    // 高度
    height: {
      type: [Number, String],
      default: "100%",
    },
    yName: {
      type: String,
      default: "线长(米)",
    },
    unit: {
      type: String,
      default: "平方米",
    },
    // 数据
    xData: {
      type: [Array, Object],
      default: () => [],
    },
    // 数据
    yData: {
      type: [Array, Object],
      default: () => [],
    },
    // 数据
    series: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  watch: {
    xData: {
      handler() {
        this.init();
      },
      deep: true,
    },
    series: {
      handler() {
        this.init();
      },
      deep: true,
    },
    yData: {
      handler() {
        this.init();
      },
      deep: true,
    },
  },
  methods: {
    init() {
      this.myChart = echarts.init(this.$refs["echartsTraingle"]);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            shadowStyle: {
              color: "rgba(55, 204, 253, 0.1)",
            },
          },
          backgroundColor: "rgba(9, 24, 48, 0.8)",
          borderColor: "rgba(75, 253, 238, 0.6)",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
          position: function (point, params, dom, rect, size) {
            let x = point[0];
            let y = point[1];
            let viewWidth = size.viewSize[0];
            let viewHeight = size.viewSize[1];
            let boxWidth = size.contentSize[0];
            let boxHeight = size.contentSize[1];

            if (x + boxWidth > viewWidth) {
              x = x - boxWidth;
            }
            if (y + boxHeight > viewHeight) {
              y = y - boxHeight;
            }

            return [x, y];
          },
          confine: true,
        },
        legend: {
          show: true,
          icon: "rect",
          right: 0,
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "4%",
          right: "4%",
          bottom: "3%",
          top: "15%",
          containLabel: true,
        },
        xAxis: {
          data: this.xData,
          triggerEvent: true,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255,255,255,1)",
            },
          },
          axisLabel: {
            show: true,
            rotate: 0,
            interval: 0,
            textStyle: {
              fontSize: 14,
              color: "rgba(255, 255, 255, 1)",
            },
          },
        },
        yAxis: {
          name: this.yName,
          nameTextStyle: {
            color: "rgba(255,255,255,0.5)",
            padding: [0, 0, 2, 0],
          },
          triggerEvent: true,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(255,255,255,1)",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
              fontSize: 16,
            },
          },
        },
        series:
          this.series.length > 0
            ? this.series
            : [
                {
                  name: this.yName,
                  // barMinHeight: 10,
                  type: "pictorialBar",
                  barCategoryGap: "5%",
                  symbol:
                    "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
                  itemStyle: {
                    normal: {
                      //渐变色
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: "rgba(104, 232, 255, 1)",
                        },
                        {
                          offset: 0.5,
                          color: "rgba(65, 210, 253, 0.8)",
                        },
                        {
                          offset: 1,
                          color: "rgba(55, 204, 253, 0.3)",
                        },
                      ]),
                    },
                  },
                  data: this.yData,
                  z: 10,
                },
              ],
      };
      this.myChart.setOption(option);
      window.addEventListener("resize", () => {
        this.myChart.resize(); //当浏览器窗口大小发生变化时，图表可以进行自适应
      });
    },
    getDom() {
      return this.$refs["echartsTraingle"];
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      addResizeListener(this.getDom(), this.myChart?.resize);
    });
  },
  beforeDestroy() {
    removeResizeListener(this.getDom(), this.myChart?.resize);
    this.myChart && this.myChart.dispose();
  },
};
</script>

<style scoped></style>
